import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE} from '@models/empty';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';
import {TrackingService} from '@services/tracking.service';

@Component({
  selector: 'app-rename',
  templateUrl: './rename.component.html',
  styleUrls: ['./rename.component.scss']
})
export class RenameComponent implements OnInit {

    favorite: Favorite = EMPTY_FAVORITE;
    loading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private adService: AdService,
        public dialogRef: MatDialogRef<RenameComponent>,
        public trackingService: TrackingService) {

        this.favorite = Object.assign({}, data.favorite);
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.favorite.title != "") {
            this.adService.updateFavorite(this.favorite);
            this.dialogRef.close(this.favorite);
        }
    }
}
